import GenericErrorPage from './GenericErrorPage.tsx'

export default function Error404() {
  return (
    <GenericErrorPage
      title="Oops! We can’t find that page"
      description="The requested page is unavailable. Please check the URL or return to the homepage."
    />
  )
}
